import React from "react";
import Breadcrumb from "../../../Breadcrumb/Breadcrumb";
import {
  Logo,
  SubTitle,
} from "./PaymentHeader.styles";

interface IPaymentHeaderProps {
  isPayment?: boolean;
  isInspectionType?: boolean;
  isVehicleIdentifier?: boolean;
  vehicleConfirm?: boolean;
}

const PaymentHeader = (props: IPaymentHeaderProps) => {
  const { isPayment, isInspectionType, vehicleConfirm, isVehicleIdentifier } = props;

  return (
    <>
      <Logo src="images/logo.svg" />
      <Breadcrumb />
      {!isInspectionType && isPayment && (
        <SubTitle>Quase lá! Só falta selecionar a forma de pagamento</SubTitle>
      )}
      {!isVehicleIdentifier && !vehicleConfirm && !isInspectionType && !isPayment && (
        <SubTitle>Insira seus dados pessoais</SubTitle>
      )}
      {isVehicleIdentifier && (
        <SubTitle>Insira os dados do veículo</SubTitle>
      )}
      {isInspectionType && (
        <SubTitle>Escolha um tipo para prosseguir</SubTitle>
      )}
    </>
  )
}

export default PaymentHeader;
